// Single owner of the in-progress v5 order form's sessionStorage.
//
// sessionStorage access can THROW (sandboxed iframe, private mode, storage
// disabled) — and the v5 form runs embedded as an outer form on brand sites,
// so every access must be guarded. Keeping the try/catch here means callers
// get clean, safe methods and the key lives in exactly one place.
const FORM_STORAGE_KEY = 'v5_form_values';

function readRaw() {
    try {
        return sessionStorage.getItem(FORM_STORAGE_KEY);
    } catch {
        return null;
    }
}

// Parsed saved values, or null when absent/unreadable/corrupt.
export function getFormValues() {
    const raw = readRaw();
    if (!raw) {
        return null;
    }
    try {
        return JSON.parse(raw);
    } catch {
        return null;
    }
}

export function saveFormValues(values) {
    try {
        sessionStorage.setItem(FORM_STORAGE_KEY, JSON.stringify(values));
    } catch {}
}

export function clearFormValues() {
    try {
        sessionStorage.removeItem(FORM_STORAGE_KEY);
    } catch {}
}

// True once the wizard has saved progress. Only next() writes it, and only on a
// validated advance, so this proves step 0 was passed legitimately.
export function hasFormProgress() {
    return readRaw() !== null;
}
